import { reloadChartBars } from '../../chart-datafeed/streaming_provider';

// ── Multiple-chart layout: backfill charts a bigger layout reveals ───────────
// Charts hidden by a SMALLER layout keep their datafeed subscriptions but
// become unreachable — widget.chart(i) throws "Incorrect index" beyond
// chartsCount(), so the reconnect backfill cannot resetData() them. TV also
// does not refetch when they are revealed again: it restores whatever bars they
// held when they went away. A chart hidden across a network gap therefore comes
// back still showing that gap. Backfill when the count grows.
//
// NOTE: which chart survives a collapse is left to TV's default behaviour (it
// keeps the lowest-indexed charts and drops focus to index 0, so collapsing
// with chart 3 focused shows chart 1). That is deliberate — we do not move
// symbols between slots.
//
// Returns a teardown function.

export function installMultiChartLayoutHandling(widget: any): () => void {
    let prevCount = 1;
    try { prevCount = widget.chartsCount(); } catch (e) { /* best-effort */ }

    const onLayoutChanged = () => {
        let count: number;
        try { count = widget.chartsCount(); } catch (e) { return; }
        const prev = prevCount;
        prevCount = count;
        // `force` bypasses the burst throttle — a layout switch is a deliberate
        // user action, never part of an online + visibility + socket-reopen storm.
        if (count > prev) {
            try { reloadChartBars('layout_grew', true); } catch (e) { console.info('layout reveal backfill failed', e); }
        }
    };

    // A saved-layout load can change the chart count without a layout_changed we
    // have seen — resync so the next switch compares against reality.
    const onChartLoaded = () => {
        try { prevCount = widget.chartsCount(); } catch (e) { /* best-effort */ }
    };

    widget.subscribe('layout_changed', onLayoutChanged);
    widget.subscribe('chart_loaded', onChartLoaded);

    return () => {
        try { widget.unsubscribe('layout_changed', onLayoutChanged); } catch (e) { /* best-effort */ }
        try { widget.unsubscribe('chart_loaded', onChartLoaded); } catch (e) { /* best-effort */ }
    };
}
